import en from './en'
import cn from './cn'
import zh_tw from './zh_tw'
import ja from './ja'
import ar from './ar'
import pt from './pt'
import ru from './ru'
import es from './es'
import ms from './ms'
export default {
  en, // 英文
  zh_cn: cn, // 简体中文
  zh_tw, // 繁体中文
  ja, // 日语
  ar, // 阿拉伯语
  pt, // 葡萄牙语
  ru, // 俄语
  es, // 西班牙语
  ms, // 马来语
}

